import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ScheduleButton from '../common/ScheduleButton/ScheduleButton';
import './Products.scss';

const Products = () => {
  const { t } = useTranslation();
  
  return (
    <section className="products-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6} data-aos="fade-right">
            <div className="product-image">
              <img src={require('../../assets/images/shirt-image.jpg')} alt="Product" />
            </div>
          </Col>
          <Col md={6} data-aos="fade-left">
            <div className="product-content">
              <h2 className="section-title">
                {t('products.title')}
              </h2>
              <p className="section-description my-4">{t('products.description')}</p>
              <ScheduleButton>{t('common.schedule_call')}</ScheduleButton>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Products;